import { Stack } from '@mui/material';
import { ArtistNameSkeleton, CoverArtSkeleton } from './components';
import {
  TextfieldSkeleton,
  ButtonContainer,
  ContinueButtonSkeleton,
  GoBackButtonSkeleton,
} from './styled';

const ReleaseInfoLoader = () => (
  <Stack spacing={3}>
    <ArtistNameSkeleton />
    <TextfieldSkeleton />
    <TextfieldSkeleton />
    <CoverArtSkeleton />
    <ButtonContainer>
      <GoBackButtonSkeleton />
      <ContinueButtonSkeleton />
    </ButtonContainer>
  </Stack>
);

export default ReleaseInfoLoader;
